import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

interface Integration {
  id: string;
  source: string;
  config: Record<string, unknown>;
  lastSynced: string | null;
}

export function useIntegrations() {
  return useQuery({
    queryKey: ['integrations'],
    queryFn: () => apiFetch<Integration[]>('/integrations')
  });
}

export function useConnectIntegration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      source,
      credentials,
      config
    }: {
      source: string;
      credentials: Record<string, string>;
      config?: Record<string, unknown>;
    }) =>
      apiFetch<{ id: string; source: string }>(`/integrations/${source}/connect`, {
        method: 'POST',
        body: JSON.stringify({ credentials, config })
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    }
  });
}

export function useDisconnectIntegration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (source: string) =>
      apiFetch<null>(`/integrations/${source}/disconnect`, { method: 'DELETE' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    }
  });
}

export function useSyncIntegration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (source: string) =>
      apiFetch<{ runId: string; status: string }>(`/integrations/${source}/sync`, {
        method: 'POST'
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    }
  });
}

export type { Integration };
